import { useState } from 'react';

export default function Billing() {
  const [selectedTab, setSelectedTab] = useState('overview');

  const upcomingBills = [
    {
      id: '1',
      policy: 'Life Insurance',
      amount: '$45.00',
      dueDate: '2024-12-10',
      status: 'due',
      icon: 'ri-heart-pulse-line',
      color: 'bg-purple-500'
    },
    {
      id: '2',
      policy: 'Auto Insurance',
      amount: '$156.00',
      dueDate: '2024-12-15',
      status: 'upcoming',
      icon: 'ri-car-line',
      color: 'bg-blue-500'
    },
    {
      id: '3',
      policy: 'Home Insurance',
      amount: '$89.00',
      dueDate: '2024-12-20',
      status: 'upcoming',
      icon: 'ri-home-4-line',
      color: 'bg-green-500'
    }
  ];

  const paymentHistory = [
    {
      id: '1',
      date: '2024-11-28',
      policy: 'Auto Insurance',
      amount: '$156.00',
      method: 'Auto Pay - Bank ****1234',
      status: 'completed'
    },
    {
      id: '2',
      date: '2024-11-20',
      policy: 'Home Insurance',
      amount: '$89.00',
      method: 'Credit Card ****5678',
      status: 'completed'
    },
    {
      id: '3',
      date: '2024-11-10',
      policy: 'Life Insurance',
      amount: '$45.00',
      method: 'Auto Pay - Bank ****1234',
      status: 'completed'
    },
    {
      id: '4',
      date: '2024-10-28',
      policy: 'Auto Insurance',
      amount: '$156.00',
      method: 'Auto Pay - Bank ****1234',
      status: 'completed'
    }
  ];

  const paymentMethods = [
    {
      id: '1',
      type: 'bank',
      name: 'Chase Checking',
      details: '****1234',
      isDefault: true
    },
    {
      id: '2',
      type: 'card',
      name: 'Visa Credit Card',
      details: '****5678',
      isDefault: false
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Bills & Payments</h1>
        <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
          <i className="ri-add-line mr-2"></i>
          Add Payment Method
        </button>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8 px-6">
            {[
              { id: 'overview', label: 'Overview', icon: 'ri-dashboard-line' },
              { id: 'upcoming', label: 'Upcoming Bills', icon: 'ri-calendar-line' },
              { id: 'history', label: 'Payment History', icon: 'ri-history-line' },
              { id: 'methods', label: 'Payment Methods', icon: 'ri-bank-card-line' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setSelectedTab(tab.id)}
                className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  selectedTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <i className={`${tab.icon} mr-2`}></i>
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="p-6">
          {selectedTab === 'overview' && (
            <div className="space-y-6">
              {/* Payment Summary */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6 rounded-lg text-white">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-blue-100">Total Monthly Premium</p>
                      <p className="text-3xl font-bold">$290.00</p>
                    </div>
                    <i className="ri-money-dollar-circle-line text-4xl text-blue-200"></i>
                  </div>
                </div>
                
                <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 rounded-lg text-white">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-green-100">Next Payment</p>
                      <p className="text-2xl font-bold">Dec 10</p>
                      <p className="text-green-100 text-sm">$45.00 due</p>
                    </div>
                    <i className="ri-calendar-check-line text-4xl text-green-200"></i>
                  </div>
                </div>
                
                <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-6 rounded-lg text-white">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-purple-100">Auto Pay</p>
                      <p className="text-2xl font-bold">Enabled</p>
                      <p className="text-purple-100 text-sm">3 policies</p>
                    </div>
                    <i className="ri-refresh-line text-4xl text-purple-200"></i>
                  </div>
                </div>
              </div>

              {/* Recent Activity */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Payments</h3>
                <div className="space-y-3">
                  {paymentHistory.slice(0, 3).map((payment) => (
                    <div key={payment.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                          <i className="ri-check-line text-green-600"></i>
                        </div>
                        <div>
                          <p className="font-medium text-gray-900">{payment.policy}</p>
                          <p className="text-sm text-gray-500">{new Date(payment.date).toLocaleDateString()}</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="font-semibold text-gray-900">{payment.amount}</p>
                        <p className="text-sm text-gray-500">{payment.method}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {selectedTab === 'upcoming' && (
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900">Upcoming Bills</h3>
                <button className="text-blue-600 hover:text-blue-700 text-sm font-medium cursor-pointer">
                  Pay All Bills
                </button>
              </div>
              
              <div className="space-y-4">
                {upcomingBills.map((bill) => (
                  <div key={bill.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                    <div className="flex items-center space-x-4">
                      <div className={`w-12 h-12 ${bill.color} rounded-lg flex items-center justify-center`}>
                        <i className={`${bill.icon} text-2xl text-white`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900">{bill.policy}</h4>
                        <p className="text-sm text-gray-500">Due {new Date(bill.dueDate).toLocaleDateString()}</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="text-right">
                        <p className="font-semibold text-gray-900">{bill.amount}</p>
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          bill.status === 'due' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'
                        }`}>
                          {bill.status === 'due' ? 'Due Now' : 'Upcoming'}
                        </span>
                      </div>
                      <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                        Pay Now
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {selectedTab === 'history' && (
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900">Payment History</h3>
                <button className="text-blue-600 hover:text-blue-700 text-sm font-medium cursor-pointer">
                  Download Statement
                </button>
              </div>
              
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Policy</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment Method</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {paymentHistory.map((payment) => (
                      <tr key={payment.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {new Date(payment.date).toLocaleDateString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{payment.policy}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{payment.amount}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{payment.method}</td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            Completed
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {selectedTab === 'methods' && (
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">Payment Methods</h3>
              
              <div className="space-y-4">
                {paymentMethods.map((method) => (
                  <div key={method.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                        <i className={`${method.type === 'bank' ? 'ri-bank-line' : 'ri-bank-card-line'} text-2xl text-gray-600`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900">{method.name}</h4>
                        <p className="text-sm text-gray-500">{method.details}</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2">
                      {method.isDefault && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                          Default
                        </span>
                      )}
                      <button className="p-2 text-gray-400 hover:text-gray-600 cursor-pointer">
                        <i className="ri-edit-line"></i>
                      </button>
                      <button className="p-2 text-gray-400 hover:text-red-600 cursor-pointer">
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}